import { Card, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadiusMd,
  boxShadow: theme.customShadows.z8,
  border: `1px solid ${theme.palette.grey[200]}`
}));

const FormCard = ({ children, sx = {}, ...props }) => {
  return (
    <StyledFormCard sx={sx} {...props}>
      {children}
    </StyledFormCard>
  );
};

export default FormCard;
